define([
	"dojo/_base/declare",
	"csi/html",
	"csi/gallery/Delete"
], function(declare,html,Delete) {

	return declare(Delete, {	
		urlOriginal: null,
		
		preProcess: function() {
			// summary: track top comment if deleting reply
			if (this.urlOriginal = this.widget.getOriginalComment(this.getNode())) {
				this.refNode = html.queryDom([html.getDataAttributeSelector(html.DATA_URL, this.m_urlNode)], this.refNode, true);
				this.nDelete = 0;
			}

			this.inherited(arguments);
		},
		
		postProcessSuccess: function() {		
			// summary: update comments and actions after deleting
			if (this.urlOriginal) {	
				html.destroyElement(this.refNode);
				this.widget.updateActions(this.urlOriginal);
				this.widget.publishDomChange();
			} else {
				this.inherited(arguments);
			}
		}
	});
});